export default {
  getInsuranceType(insuranceTypeKey) {
    // Load insurance type data file from source code
    // Move this to a DB long-term
    return Promise.resolve({
      data: require(`../../data/insurance_types/${insuranceTypeKey}.json`)
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/InsuranceTypeService.js